import { generateClassName } from '@klaviyo-mkt/gatsby-components/shared/utils/functions';

import { TaxonomySubhead } from '../taxonomy-subhead';

import * as styles from './styles/basicArticleHero.module.scss';

import type { TPostLayout } from '../../types';

export const BasicArticleHero = ({
  customers,
  featuredImage,
  industries,
  platforms,
  title,
}: {
  customers: TPostLayout['customers'];
  featuredImage: TPostLayout['featuredImage'];
  industries: TPostLayout['industries'];
  platforms: TPostLayout['platforms'];
  title: TPostLayout['title'];
}) => (
  <>
    <h1 className={generateClassName([styles.basicLayout, styles.postHeadline])}>{title}</h1>

    <TaxonomySubhead
      customers={customers}
      industries={industries}
      platforms={platforms}
    />

    {featuredImage && (
      <figure className={generateClassName([styles.basicLayout, styles.featuredImage])}>
        {featuredImage.node?.sourceUrl && (
          <img
            alt={featuredImage.node?.altText}
            sizes='(max-width: 1023px) 100vw, (max-width: 1199px) 733px, (max-width: 1365px) 822px, 792px'
            src={featuredImage.node.sourceUrl}
            srcSet={featuredImage.node.srcSet}
          />
        )}
        {featuredImage.node?.caption && (
          <figcaption
            className={styles.featuredImageCaption}
            dangerouslySetInnerHTML={{ __html: featuredImage.node?.caption }}
          />
        )}
      </figure>
    )}
  </>
);
